import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Sheet, SheetContent } from '@shared/components/ui/sheet';
import { useUiStore } from '@app/store/ui.store';
import { AdminSidebar } from './AdminSidebar';

/**
 * On mobile the sidebar renders inside a Sheet (slide-over drawer).
 * Uses a separate open flag so closing the drawer never collapses the
 * desktop sidebar labels.
 */
export function AdminMobileSidebar() {
  const { mobileNavOpen, setMobileNavOpen } = useUiStore();
  const { pathname } = useLocation();

  useEffect(() => {
    setMobileNavOpen(false);
  }, [pathname, setMobileNavOpen]);

  return (
    <Sheet open={mobileNavOpen} onOpenChange={setMobileNavOpen}>
      <SheetContent side="left" className="w-64 p-0">
        <AdminSidebar forceExpanded />
      </SheetContent>
    </Sheet>
  );
}
